(function() {
  function init() {
    var sections = document.querySelectorAll('.section-image-with-text-contained');
    sections.forEach(function(section) {
      var video = section.querySelector('video');
      if (!video) return;

      video.muted = true;

      var playVideo = function() {
        video.play().catch(function() {});
      };

      playVideo();

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              playVideo();
            }
          });
        }, { threshold: 0.1 });
        observer.observe(video);
      }

      window.addEventListener('load', playVideo);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();